module.exports = __webpack_public_path__ + "img/need_in.be880ddd.svg";